const DATA = [
  {
    img: 'images/client_logos/cisco.png',
    client: 'Cisco Systems',
    location: 'Bangalore, India',
  },
  {
    img: 'images/A_Major_Crypto_logo.png', // Should use this image. ~images/A_Major_Crypto_logo.png
    client: 'A Major Crypto Start-Up',
    location: 'USA',
  },
  {
    img: 'images/client_logos/pickyourtrail.svg',
    client: 'Pick your trail',
    location: 'India',
  },
  {
    img: 'images/client_logos/ThoughtFocusClient.png',
    client: 'ThoughtFocus',
    location: 'India',
  },
  {
    img: 'images/client_logos/SpringworksClientLogo.png',
    client: 'Springworks',
    location: 'India',
  },
  {
    img: 'images/client_logos/RizoomiClientLogo.png',
    client: 'Rizoomi',
    location: 'Australia',
  },
  {
    img: 'images/client_logos/nutanix.png',
    client: 'Nutanix',
    location: 'San Jose, CA',
  },
  {
    img: 'images/client_logos/lumos.png',
    client: 'Lumos',
    location: 'USA',
  },
  {
    img: 'images/client_logos/tivo.png',
    client: 'Tivo Inc.',
    location: 'Alviso, CA',
  },
  {
    img: 'images/roblox.png',
    client: 'Roblox.com',
    location: 'San Mateo, CA',
  },
  {
    img: 'images/client_logos/paqs.png',
    client: 'PAQS',
    location: 'India',
  },
  {
    img: 'images/client_logos/synox.png',
    client: 'Synox',
    location: 'France',
  },
  {
    img: 'images/client_logos/rossch.png',
    client: 'Rossch Group',
    location: 'USA',
  },
  {
    img: 'images/client_logos/rigbot.png',
    client: 'RigBot',
    location: 'USA',
  },
  {
    img: 'images/client_logos/ror.png',
    client: 'Roll On Road',
    location: 'India',
  },
  {
    img: 'images/client_logos/seoradar.png',
    client: 'SEORadar',
    location: 'USA',
  },
  {
    img: 'images/client_logos/goibibo.png',
    client: 'Goibibo',
    location: 'India',
  },
  {
    img: 'images/client_logos/unboundly.png',
    client: 'Unboundly',
    location: 'USA',
  },
  {
    img: 'images/client_logos/ifly.png',
    client: 'iFly.com',
    location: 'USA',
  },
  {
    img: 'images/client_logos/amick.png',
    client: 'AmickBrown',
    location: 'USA',
  },
  {
    img: 'images/client_logos/rchive.png',
    client: 'Rchive',
    location: 'USA',
  },
  {
    img: 'images/client_logos/wehub.png',
    client: 'WeHub',
    location: 'Japan',
  },
  {
    img: 'images/client_logos/byeh.png',
    client: 'BYEH',
    location: 'USA',
  },
  {
    img: 'images/softeventlogo.jpg',
    client: 'Softvent India',
    location: 'Bangalore, India',
  },
  {
    img: 'images/client_logos/metis.png',
    client: 'Metis',
    location: 'Japan',
  },
  {
    img: 'images/client_logos/aditazz.jpg',
    client: 'Aditazz',
    location: 'USA',
  },
  {
    img: 'images/client_logos/uplift.png',
    client: 'Uplift',
    location: 'USA',
  },
  {
    img: 'images/client_logos/rybot.png',
    client: 'Rybot',
    location: 'USA',
  },
  {
    img: 'images/SCube/SCubelogo.png',
    client: 'S Cube Ergonomics Pvt. Ltd.',
    location: 'India',
  },
];
export default DATA;



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/clients/clientsData.js